import ReactStrapTable from 'components/reactStrapTable';
import { Field, Formik } from 'formik';
import React, { useEffect, useState } from 'react'
import HoverImage from 'react-hover-image/build';
import ReactSelect from 'react-select';
import { Button, Card, CardBody, Col, Container, FormGroup, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, UncontrolledTooltip } from 'reactstrap'
import EditIcon from 'assets/icon/icon-icon-options-edit.svg';
import ConfigIcon from "assets/icon/config-setting-icon.svg";
import ConfigIconHover from "assets/icon/config-setting-icon-hover.svg";
import EditHoverIcon from 'assets/icon/icon-icon-options-edit_hover.svg';
import { cellRendererCheck, dateFormate } from 'utils/columns';
import { OverlayTrigger } from 'react-bootstrap';
import FormikDatePicker from 'components/common/Fields/FormikDatePicker';
import Calendar from 'assets/icon/calendar-icon.svg';
import CancleIcon from 'assets/icon/icon-icon-options-not-eligible.svg';
import SaveIcon from 'assets/icon/icon-icon-options-order-complete.svg';
import CellEditRender from 'components/reactStrapTable/components/CellEditRender';
import CancleHoverIcon from 'assets/icon/icon-icon-options-not-eligible-hover.svg';
import SaveHoverIcon from 'assets/icon/icon-icon-options-order-complete-hover.svg';
import ErrorBoundary from 'components/ErrorBoundary';
import useAxios from 'hooks/useAxios';
import useContextService from 'hooks/useContextService';
import { toast } from 'react-toastify';
import Confirm from 'components/Confirm';
import { format } from 'date-fns';
import { ModuleAccess } from 'utils/moduleaccess';
import reseticon from "assets/icon/reset.svg";
import search from "assets/icon/search.svg";
import plus from "assets/icon/Add-White-Icon.svg";
import FormikSelectField from 'components/common/Fields/FormikSelectField';
import cancel from "assets/icon/cancel.svg";
import save from "assets/icon/save.svg";
import { cloneDeep, filter } from 'lodash';

let rowForEdit = {};
let updatedFields = {};

let hasDatePopupOpen = false;
const Rule = (props) => {
  const {
    states: { configRlueType },
    setStates,
  } = useContextService();
  const { search, } = configRlueType;

  const API = useAxios();
  const {
    orgId,
    rowData,
    ruleData,
    selectedRule,
    selectedStatus,
    SelectedAccumulatorRule,
    handleResetRule,
    handledesablestatus,
    StatusHardCodedata,
    RuleHardCodedata,
    desablestatus,
    handelRuleChange,
    setLoading,
    loading,
    keyname,
    handlestu,
    setSelectedRule,

    //statusdesable,
  } = props;

  let initialStates = {
    currentPage: 1,
    pageSize: 100,
    order: 'desc',
    orderBy: 'modifiedDate',
    Filters: [],
    AccumulatorID: rowData ? rowData.accumulatorID : 0,
    ActivityID: selectedStatus ? selectedStatus.value : 0,
    RuleLevelID: selectedRule ? selectedRule.value : 0,
    CEID: rowData.coveredEntityID,
  }


  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [tableData, setTableData] = useState([])
  // const [loading, setLoading] = useState(false)
  const [hasCriteria, setCriteria] = useState(false);
  const [criteriaVal, setCriteriaVal] = useState("");
  const [criteraError, setCriteraError] = useState("")
  const [totalRecords, setTotalReocrds] = useState("")
  let CriteriaError = 'Please Type Criteria ';

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasTouched, setTouched] = useState('');
  const [isConfirm, setConfirm] = useState(false);
  const [statusdesable, setStatusdesable] = useState(false);
  const [columnFilters, setColumnFilters] = useState([]);

  const [state, updateState] = useState({
    tableData: [],
    backUpData: [],
    filters: search,
  })

  useEffect(() => {
    setState({ tableData: tableData, backUpData: tableData });
  }, [tableData]);
  const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

  useEffect(() => {
    setState({ filters: search });
  }, [search]);


  let addDisabled = SelectedAccumulatorRule?.vale == null && selectedStatus?.value == null && selectedRule?.value == null ? false : true
  const toggle = () => setModal(!modal);


  let saveDisabled = SelectedAccumulatorRule?.length > 0 ? true : false

  const handleSaveConfirmation = () => {
    setConfirm(!isConfirm);
  };

  const cellRenderEdit = (rowData) => {
    if (hasPermission('ED'))
      if (rowData.isEdit) {
        return (
          <div className='d-flex align-items-center'>
            <Button
              className='text-primary p-0 text-decoration-none'
              color='link'
              onClick={handleSaveConfirmation}
              title="Save"
            >
              <HoverImage
                key='SaveIcon'
                src={SaveIcon}
                hoverSrc={SaveHoverIcon}
                alt=''
              />
            </Button>
            <Button
              className='text-primary p-0 text-decoration-none'
              color='link'
              onClick={() => editRow(rowData, false)}
              title="Cancel"
            >
              <HoverImage
                key='CancelIcon'
                src={CancleIcon}
                hoverSrc={CancleHoverIcon}
                alt=''
              />
            </Button>
          </div>
        );
      } else {

        return (
          <div className='d-flex align-items-center'>
            {renderEditButton(rowData)}

          </div>
        );
      }
  };

  const handlecCancelFilter =() =>{
    refetch();
  }
  const handelStatusChange =async  (e)=>{
    await handlestu(e);
  }

  // const editRow = (rowData, isEdit = true) => {
  //   let tempData = [...data];
  //   tempData = tempData.map((row) => {
  //     row.isEdit = false;
  //     if (row.ceServiceLocationID === rowData?.ceServiceLocationID && isEdit) {
  //       row.isEdit = isEdit;
  //       rowForEdit = row;
  //     }
  //     return row;
  //   });
  //   // setTouched('');
  //   // setSelectedStatus('');
  //   updatedFields = {};
  //   //  tableDataBackup = tempData;
  //   setData(tempData);
  // };

  const checkvalidation = (selectedvaluesonly) => {
    debugger;
    if (selectedvaluesonly.inactiveFlag == null || selectedvaluesonly.inactiveFlag == "") {
      toast.error('Active Flag is Required');
      return true;
    }

    // else if ((selectedvaluesonly.reason == undefined || selectedvaluesonly.reason == null || selectedvaluesonly.reason == "")) {
    //     toast.error('Reason is requied');
    //     return true;

    // }
    else {
      return false;
    }

  }
  const editRow = (rowData, isEdit = true) => {
    debugger;
    let tempData = [...tableData];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.ruleConfigurationID === rowData?.ruleConfigurationID && isEdit) {
        row.isEdit = isEdit;
        // row.modifiedDate=new Date();


        rowForEdit = row;
        console.log(rowForEdit, "rowForEdit in edit Row")
        console.log(row, "row in edit Row")
      }
      return row;
    });
    setTouched('');
    updatedFields = {};
    setTableData(tempData);
  };
  const savePanelUpdateRow = async () => {
    debugger;
    handleSaveConfirmation();
    if (checkvalidation(rowForEdit))
      return true;

    setLoading(true);
    const payload = { ...rowForEdit };
    // payload.ActiveFlag = payload.inactiveFlag;
    // payload.ModifiedDate = payload.modifiedDate
    payload.modifiedDate = format(new Date(), "yyyy-MM-dd HH:mm:ss");
    delete payload.isEdit;
    try {
      const result = await API.post(
        `SBTenant/${orgId.tenantID}/Configuration/EditRuleConfiguration`,
        payload,
        {
          hasDefaultURL: true,
        },
      );
      if (result) {
        if (result.data.error) {
          toast.error(result.data.message);
        }
        else {
          toast.success('Rules Updated Successfully');

        }
        setLoading(false);
        refetch(initialStates);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      refetch(initialStates);
    }
  };
  useEffect(() => {
    debugger;
    fetchRuleListTable(initialStates);

  }, [SelectedAccumulatorRule, selectedRule, selectedStatus]);

  useEffect(() => {
    debugger;
    newHandleReset()
  }, [keyname]);


const handleColumnFilter = async(colFilter) =>{
  debugger;
      const filterObj = cloneDeep(search);
      if (colFilter && colFilter.length > 0) {
        filterObj.filters = [...filterObj.filters, ...colFilter];
        setColumnFilters(colFilter);
      }
      await fetchRuleListTable(filterObj);
    };



  const fetchRuleListTable = async (filterObj) => {
    debugger;
    if (filterObj != undefined) {
      initialStates.Filters = filterObj.Filters
      initialStates.order = filterObj.order ? filterObj.order : initialStates.order
      initialStates.orderBy = filterObj.orderBy ? filterObj.orderBy : initialStates.orderBy
      initialStates.currentPage = filterObj.currentPage ? filterObj.currentPage : initialStates.currentPage
      filterObj.AccumulatorID = filterObj.AccumulatorID ? filterObj.AccumulatorID : initialStates.AccumulatorID
      filterObj.RuleLevelID = filterObj.RuleLevelID ? filterObj.RuleLevelID : initialStates.RuleLevelID
      filterObj.ActivityID = filterObj.ActivityID ? filterObj.ActivityID : initialStates.ActivityID
      filterObj.CEID = filterObj.CEID ? filterObj.CEID : initialStates.CEID
    }
    if (filterObj == undefined) {
      filterObj = initialStates
    }
    // getmodel.RuleList=RuleList

    if (SelectedAccumulatorRule && selectedRule && selectedStatus) {
      setLoading(true);
      try {
        const { data } = await API.post(`SBTenant/${orgId.tenantID}/Configuration/GetRuleConfigurationDetails`,
          filterObj, { hasDefaultURL: true, }

        );
        setLoading(false);
        if (data?.items?.length > 0) {
          setTableData(data.items);
          handledesablestatus();
          setCriteria(true)
          setTotalReocrds(data.totalRecords)
        }
        else{
          setTableData([]);
          setTotalReocrds(0)
        }
      } catch (error) {
        console.error("API call failed:", error.response ? error.response.data : error.message);
        setLoading(false);
      }
    }
    // }
  }

  const hasPermission = (code) => {
    return ModuleAccess("CON", code);
  }
  const renderEditButton = (rowData) => {
    if (hasPermission('ED'))
      return <Button
        className='text-primary p-0 text-decoration-none'
        color='link'
        onClick={() => editRow(rowData)}
        title='Edit Rule'
      >
        <HoverImage src={EditIcon}
          hoverSrc={EditHoverIcon}
          alt='' />
      </Button>
  }

  const renderConfigButton = () => {

    return <Button
      className='text-primary p-0 text-decoration-none'
      color='link'
      // onClick={() => handleConfig()}
      title='Client Configuration'

    >
      <HoverImage
        src={ConfigIcon}
        hoverSrc={ConfigIconHover}
        alt='' />
    </Button>
  }

  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };

  const handleDateClick = (id) => {

    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };
  const updateRowValue = (value, col) => {
    debugger
    const tempRow = { ...rowForEdit };
    tempRow[col] = value;
    rowForEdit = tempRow;
  };
  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {

    return (
      <CellEditRender
        row={row}
        col={col}
        formatterType={formatterType}
        hasTouched={hasTouched}
        onChange={updateRowValue}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
      />
    );
  };
  const renderCheckBox = (rowData, col) => {
    return (
      <Input
        className="text-primary p-0 text-decoration-none"
        type="checkbox"
        checked={rowData.inactiveFlag === "N"}
        disabled={!rowData.isEdit}
        title="Active"
      />
    );
  };

  const refetch = async (initia) => {
    setColumnFilters([]);
    fetchRuleListTable(initia)
  }


  const newHandleReset = () => {
    handleResetRule();
    setTableData([]);

  }
  let mainCol = [

    {
      dataField: 'edit',
      text: 'Options',
      cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 80,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: 'ruleValue',
      text: 'Criteria',
      sort: true,
      width: 180,
      show: true,
      inputType: 'text',
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.ruleValue),
    },
    {
      dataField: 'inactiveFlag',
      text: 'Active',
      sort: false,
      width: 100,
      show: true,
      inputType: 'text',
      hideColFilter: false,
      edit: true,
      cellRenderer: (rowData, col) => rowData.isEdit == true ? formatter(rowData, col, "checkbox", true) : renderCheckBox(rowData, col),
    },
    {
      dataField: 'modifiedByID',
      text: 'Modified By',
      sort: false,
      width: 180,
      show: true,
      inputType: 'text',
      hideColFilter: false,
      cellRenderer: (row) => cellRendererCheck(row.modifiedByID),
    },
    {
      dataField: 'modifiedDate',
      text: 'Modified Date',
      sort: true,
      width: 180,
      show: true,
      inputType: 'date',
      hideColFilter: false,
      cellRenderer: (row) => dateFormate(row.modifiedDate),
    },



  ];

  const handleSubmit = async () => {
    if (isSubmitting) return; // If already submitting, return early.
    setIsSubmitting(true); // Set isSubmitting to true to block further clicks.
    setLoading(true)
    setStatusdesable(true);
    if (!criteriaVal) {
      setCriteraError("Enter Criteria")
    }

    let addrulelist = [];
    var lst = {};
    var addmodel = {}
    lst.CEID = rowData.coveredEntityID;
    lst.AccumulatorID = SelectedAccumulatorRule;
    lst.RuleValue = criteriaVal;
    lst.RuleLevelID = selectedRule ? selectedRule.value : 0;
    lst.ActivityID = selectedStatus ? selectedStatus.value : 0;
    if (criteriaVal.length > 0) {
      setLoading(true);
      try {
        // 
        const result = await API.post(`SBTenant/${orgId.tenantID}/Configuration/AddRuleConfiguration`, lst,
          {
            hasDefaultURL: true,
            hideLoader: true,
          }
        );


        if (result) {
          setLoading(false);
          toast.success('Rule saved successfully');
          refetch(initialStates);
          // manvalPharmacy()

        }
      } catch (error) {
        console.log(error);
      }
      setIsSubmitting(false);
      setLoading(false);
      toggle();
      setCriteriaVal("");
    }
  }


  const handleCancel = () => {
    setCriteriaVal("");
    toggle();
  }
  const handleCritera = ({ target: { value } }) => {
    console.log(value, "Criteria Value");
    setCriteriaVal(value);
    if (value.length > 0) {
      setCriteraError("")
    }
  }
  const handleExport = async () => {
    debugger;

    const filterObj = cloneDeep(search);
    filterObj.AccumulatorID = SelectedAccumulatorRule;
    filterObj.RuleLevelID = selectedRule.value;
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }

    const { access_token } =
      JSON.parse(localStorage.getItem('pharmaforce')) || {};

    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    additionalCriteria.OrgId = orgId.organizationID;
    additionalCriteria.AccumulatorID = filterObj.AccumulatorID;
    // additionalCriteria.POId = SE;

    var payload = {};

    payload.tenantID = orgId.tenantID
    payload.gridCode = "chargerules";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });

  };
    const handleSort = async(filter, hasColFilter) => {
        setState({
            filters: filter,
        });
        if (hasColFilter) {
             await fetchRuleListTable(filter);
        } else {
           await fetchRuleListTable(filter);
        }
    };
const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
  debugger;
        if (hasColFilter) {
            setState({
                filters: filter,
            });
            let colFilterOn = { ...filter, filters: colChangedFilter };
            return fetchRuleListTable(colFilterOn, true);
        }
        setState({
            filters: filter,
        });

        fetchRuleListTable(filter);
        configRlueType.search ={...configRlueType.search, ...filter}
        setState('configRuleType', configRlueType);
    };
  return (
    <div>
      <div>
        <div>
          <div>
            <Formik

              children={(props) => {
                const {
                  isSubmitting,
                  handleSubmit,
                  resetForm,
                  setFieldValue,
                  errors,
                  touched,
                } = props;
                return (
                  <div hidden={""}>
                    {/* <Row>
                      <Col md="4" className="m-0 f-14 mt-2 rule">
                        {" "}
                        <p className="m-0 f-14 mt-1">Rule</p>
                        <ReactSelect
                          id="rule"
                          name="rule"
                          value={selectedRule}
                          options={RuleHardCodedata}
                          // component={FormikSelectField}
                          placeholder="Select Rule"
                          onChange={(e) => handelRuleChange(e)}
                          keys={{
                            value: "value",
                            label: "label",
                          }}
                        />
                      </Col>

                      <Col md="4" className="m-0 f-14 mt-3 rule">
                        {" "}
                        <p className="m-0 f-14 ">Status</p>
                        <ReactSelect
                          id="status"
                          name="status"
                          value={selectedStatus}
                          options={StatusHardCodedata}
                          isDisabled={desablestatus}
                          placeholder="Select Status"
                          component={FormikSelectField}
                          // onChange={(e) => handelStatusChange(e)}
                          keys={{
                            value: "value",
                            label: "label",
                          }}
                        />
                      </Col>
                    </Row> */}
                    <Row className=''>
                      <FormGroup className='d-flex'>
                        <Col md="4" >
                          {/* {" "} */}
                          <Label>Rule</Label>
                          <ReactSelect
                            id="rule"
                            name="rule"
                            value={selectedRule}
                            options={RuleHardCodedata}
                            // component={FormikSelectField}
                            placeholder="Select Rule"
                            onChange={(e) => handelRuleChange(e)}
                            keys={{
                              value: "value",
                              label: "label",
                            }}
                            className="required"
                          />
                        </Col>
                        <Col md={1}>&nbsp;</Col>
                        <Col md="4" >
                          {/* {" "} */}
                          <Label>Status</Label>
                          <ReactSelect
                            id="status"
                            name="status"
                            value={selectedStatus}
                            options={StatusHardCodedata}
                            isDisabled={desablestatus && tableData?.length > 0}
                            placeholder="Select Status"
                            component={FormikSelectField}
                            onChange={(e) => handelStatusChange(e)}
                            keys={{
                              value: "value",
                              label: "label",
                            }}
                            className="required"
                          />
                        </Col>
                      </FormGroup>
                    </Row>
                    <Row sm={5} style={{ justifyContent: "flex-end" }}>
                      <Col md="auto" className="">
                        <Label>{""}</Label>
                        <Button
                          color="primary"
                          className="reset"
                          onClick={newHandleReset}
                          disabled={!(selectedStatus || selectedRule)}
                        >
                          <span className="right_5">
                            <img src={reseticon} alt="" />
                          </span>{" "}
                          Reset
                        </Button>
                        <Button
                          color="primary"
                          className="search"
                          onClick={toggle}
                          hidden={!hasPermission("AD")}
                          disabled={
                            !(
                              selectedStatus &&
                              selectedRule &&
                              SelectedAccumulatorRule
                            )
                          }
                        >
                          <span className="right_5">
                            {" "}
                            <img src={plus} alt="" />
                          </span>{" "}
                          Add
                        </Button>
                      </Col>
                    </Row>
                  </div>
                );
              }}
            ></Formik>
            <div className="pt-0">
              <div
                className="table-card scroll-table position-relative border-0 rounded pt-2"
                fixed-height={tableData.length > 0 ? "fixed-height" : "default"}
              >
                <ReactStrapTable
                  id="rule-table"
                  height={550}
                  fixedColumn
                  //loading={loading}
                  width={1200}
                  data={tableData}
                  columns={mainCol}
                  onExport={handleExport}
                  filters={search}
                  totalRecords={totalRecords}
                  pageSize={search.pageSize}
                  currentPage={search.currentPage}
                  onPageSizeChange={onPageSizeChange}
                  onFilterCancel={handlecCancelFilter}
                 onSearchColumnFilters={handleColumnFilter}
handleSort={handleSort}

                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Confirm
        isOpen={isConfirm}
        loading={loading}
        message='Do you want to continue with the changes?'
        onToggle={handleSaveConfirmation}
        onCancel={handleSaveConfirmation}
        onContinue={savePanelUpdateRow}
      />
      <Modal isOpen={modal} fade={false} toggle={toggle}>
        {/* <Modal isOpen={modal} fade={false} toggle={toggle} className={props.className}> */}
        <ModalHeader toggle={toggle}>
          <h5 className="f-15 text-primary font-weight-700 mt-2">
            Add Criteria
          </h5>
        </ModalHeader>
        <ModalBody>
          <Formik

            children={(props) => {
              return (
                <div hidden={""}>
                  <Row sm={5}>
                    <Col md={12} lg={12} sm={12} xs={12}>
                      {" "}
                      <FormGroup>
                        <Label for="Criteria">Criteria</Label>
                        <Input
                          id="Criteria"
                          name="Criteria"
                          type="text"
                          placeholder="Enter Criteria"
                          autoComplete="off"
                          value={criteriaVal}
                          onChange={handleCritera}

                          component={""}
                        // onChange={(e) => { handleInvoiceNumberOnChange(e, setFieldValue) }}
                        />
                        {/* {!hasCriteria ? (
                          <div className="text-danger f-12 position-absolute">
                            {CriteriaError}
                          </div>
                        ) : null} */}
                        {criteraError ? (
                          <div className="text-danger f-12">
                            {criteraError}
                          </div>
                        ) : null}
                      </FormGroup>
                    </Col>
                  </Row>

                </div>
              );
            }}
          ></Formik>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" className='search' disabled={!criteriaVal} onClick={handleSubmit}>
            <span className="right_5"><img src={save} alt="" /></span> {""}
            Save
          </Button>{" "}
          <Button color="primary" className='reset' onClick={handleCancel}>
            <span className="right_5"><img src={cancel} alt="" /></span> {""}

            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default Rule
